

import { opsApi } from "../../apis";
import { useOpsStore } from "../../stores/ops/ops";
import Swal from "sweetalert2";




export const listadoOpsStocks = async(termino) => {
    try {
        const { data } = await opsApi.get(`/listaops/stock/${termino}`);
        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}



export const opPorID = async(id) => {
    try {
        const { data } = await opsApi.get(`/opxid/${id}`);
        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        console.log(errores)
        throw new Error(errores);
    }
}



export const listadoOpsTodas = async({ page=0, termino='', inicio, final }) => {
    try {
        const params = new URLSearchParams();
        params.append('page',  page.toString());
        params.append('termino',  termino);
        params.append('inicio',  inicio);
        params.append('final',  final);

        const { data } = await opsApi.get('/todas', { params });
        useOpsStore.setState({ totalOps: data.total });
        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}



export const cambiarEstadoOp = async(id) => {
    try {
        const { data } = await opsApi.put(`/estado-op/${id}`);
        Swal.fire('Exitoso', data.msg, 'success');
        return true;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        throw new Error(errores);
    }
}




export const startComprarOP = async( datos ) => {
    try {
        const formData = new FormData();
        if(datos?.imgPago && typeof datos?.imgPago !== 'string') { formData.append('images', datos.imgPago); }
        Object.entries(datos).forEach(([key, value]) => {
            formData.append(key, value?.toString());
        });

        const { data } = await opsApi.post('new', formData);
        Swal.fire(  
            `Tu Op es: ${ data.data.op }`, 
            `Todo trabajo se inicia con un abono de <b>50% del valor total</b> y el saldo a la entrega del mismo. No se hace devolución de dinero una vez iniciado el trabajo. No nos hacemos responsables por trabajos pasados <b>30 dias desde la fecha de solicitud.</b> en caso de correcciones, se validaran maximo al siguiente dia de la entrega. Los diseños realizados por nosotros no seran impresos sin antes ser <b>aprobados por el cliente, REVISE MUY BIEN LOS DISEÑOS, no nos hacemos responsables por errores de ortografia, redacción, alineación, diagramación, tamaño del texto, logos, numeros telefonicos, correos, direcciones, fuentes, colores y demas después de la APROBACIÓN E IMPRESIÓN.</b> Tenga en cuenta que los colores en pantalla tienden a variar en la impresión, <b>No</b> nos comprometemos a sacar colores ni tamaños exactos. Recuerde que según la disponibilidad de tiempo se programa una posible fecha de entrega  <b>por ende los trabajos para entrega inmediata o a domicilio tienen un costo adicional el cual se validara con su distribuidor autorizado o directamente con la empresa.</b>`, 
            'success'
        );
        return true;

    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
} 



export const listadoOpsXUser = async({ page=0, termino='', inicio, final, id, estadoPago }) => {
    try {
        const params = new URLSearchParams();
        params.append('id',  id);
        params.append('page',  page.toString());
        params.append('termino',  termino);
        params.append('inicio',  inicio);
        params.append('final',  final);
        params.append('estadoPago',  estadoPago);

        const { data } = await opsApi.get(`/opxuser`, { params });
        useOpsStore.setState({ totalOps: data.total });
        return data.data;
        
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}



export const startEditarItemsEnOps = async( body ) => {
    try {
        const { data } = await opsApi.put(`/upload/items`, body);
        Swal.fire('Exitoso', data.msg, 'success');
        return true;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}



export const startDeleteItemDeOP = async( id ) => {
    try {
        const { data } = await opsApi.delete(`/delete/${id}`);
        Swal.fire('Exitoso', data.msg, 'success');
        return true;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
} 




export const startDeleteOpAdmin = async(id) => {
    try {
        await opsApi.delete(`/adminop/${id}`);
        Swal.fire('Exitoso', 'Op eliminada con todo sus datos', 'success');
        return true;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
} 












